import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Landing from './Landing'
import NotFoundPage from './NotFoundPage'
import ReferralPartner from '../lib/referralPartner'
import { isReferralPartner } from '../constants/referralPartners'

// The co-branded landing page is for unauthenticated visitors only — it is registered in the
// guest route tree alone. Recording the partner here is what carries the attribution through
// the full-page hop to /auth, where it is sent with the signup request.
const PartnerLanding = () => {
  const { partner } = useParams()
  const known = isReferralPartner(partner)

  useEffect(() => {
    if (known) ReferralPartner.remember(partner)
  }, [known, partner])

  if (!known) {
    return (
      <NotFoundPage message="If you received a partner invitation link, please check the link and try again." />
    )
  }

  return <Landing partner={partner} />
}

export default PartnerLanding
